/* eslint-disable @typescript-eslint/naming-convention */

export const FOOTER_COPY: Record<string, string> = {
    nl: 'Alle rechten voorbehouden.',
    fr: 'Tous droits réservés',
};

export interface Link {
    [title: string]: string;
}

export const BASE_DOMAIN = 'https://www.assuralia.be';

export const LINKS: Record<string, Record<string, Link[]>> = {
    fr: {
        Assuralia: [
            { Pressroom: 'https://press.assuralia.be/fr' },
            { Jobs: `${BASE_DOMAIN}/fr/jobs` },
            { Contact: `${BASE_DOMAIN}/fr/nous-contacter` },
        ],
        Topics: [
            { 'Infos secteur': `${BASE_DOMAIN}/fr/infos-secteur` },
            {
                'Etudes et chiffres': `${BASE_DOMAIN}/fr/etudes-et-chiffres`,
            },
            {
                Durabilité: `${BASE_DOMAIN}/fr/la-durabilite-dans-le-secteur-de-lassurance`,
            },
            { Glossaire: `${BASE_DOMAIN}/fr/glossaire` },
        ],
        Thèmes: [
            { Santé: `${BASE_DOMAIN}/fr/sante` },
            {
                'Famille & Temps libre': `${BASE_DOMAIN}/fr/famille-temps-libre`,
            },
            {
                Habitation: `${BASE_DOMAIN}/fr/habitation`,
            },
            { Mobilité: `${BASE_DOMAIN}/fr/mobilite` },
            {
                'Epargne, Placement & Retraite': `${BASE_DOMAIN}/fr/epargne-placement-retraite`,
            },
            {
                'Travailler & Entreprendre': `${BASE_DOMAIN}/fr/travailler-entreprendre`,
            },
        ],
    },
    nl: {
        Assuralia: [
            { Pressroom: 'https://press.assuralia.be' },
            { Jobs: `${BASE_DOMAIN}/nl/jobs` },
            { Contact: `${BASE_DOMAIN}/nl/contacteer-ons` },
        ],
        Topics: [
            { 'Sector info': `${BASE_DOMAIN}/nl/sectorinfo` },
            {
                'Studies en cijfers': `${BASE_DOMAIN}/nl/studies-en-cijfers`,
            },
            {
                Duurzaamheid: `${BASE_DOMAIN}/nl/duurzaamheid-in-de-verzekeringssector`,
            },
            { Glossarium: `${BASE_DOMAIN}/nl/glossary` },
        ],
        "Thema's": [
            { Gezondheid: `${BASE_DOMAIN}/nl/gezondheid` },
            {
                'Familie & Vrije tijd': `${BASE_DOMAIN}/nl/familie-vrije-tijd`,
            },
            {
                Wonen: `${BASE_DOMAIN}/nl/wonen`,
            },
            { Mobiliteit: `${BASE_DOMAIN}/nl/mobiliteit` },
            {
                'Sparen, beleggen & Pensioen': `${BASE_DOMAIN}/nl/sparen-beleggen-pensioen`,
            },
            {
                'Werk & onderneming': `${BASE_DOMAIN}/nl/werk-onderneming`,
            },
        ],
    },
};
